/* HFB search drawer - ticket 281648391
   Populates the left search drawer from Shopify's native predictive endpoint
   (/search/suggest.json). No third-party search app involved.
   Vanilla JS, no jQuery dependency; the theme's own modal system still owns
   open/close, focus trapping and the body scroll lock. */
(function () {
  'use strict';

  var root = document.getElementById('search-modal');
  if (!root || !root.classList.contains('hfb-drawer')) return;

  var input = root.querySelector('[data-hfb-search-input]');
  var form = root.querySelector('[data-hfb-search-form]');
  var body = root.querySelector('[data-hfb-body]');
  var foot = root.querySelector('[data-hfb-foot]');
  var viewAll = root.querySelector('[data-hfb-viewall]');
  var tabs = [].slice.call(root.querySelectorAll('[data-hfb-tab]'));
  if (!input || !body || !tabs.length) return;

  /* Trending searches + trending products for the idle state. Rendered in Liquid
     (theme.liquid) because Shopify publishes no trending data to fetch - both lists
     are curated in Theme settings > Search. Held in a <template> so its images are
     not requested on every page load, and read once here. */
  var trendingTpl = root.querySelector('[data-hfb-trending]');
  var trendingHtml = trendingTpl ? trendingTpl.innerHTML : '';

  var MIN_CHARS = 2;
  var LIMIT = 10;
  var DEBOUNCE_MS = 250;

  var searchPath = (root.getAttribute('data-search-url') || '/search');
  var predictiveSearchPath = root.getAttribute('data-predictive-search-url');
  if (predictiveSearchPath) {
    predictiveSearchPath = predictiveSearchPath.replace(/\/$/, '');
    if (!/\.json$/.test(predictiveSearchPath)) predictiveSearchPath += '.json';
  } else {
    predictiveSearchPath = (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root + 'search/suggest.json'
      : '/search/suggest.json';
  }
  var searchType = (root.getAttribute('data-search-type') || 'product');
  var strings = {
    idle: root.getAttribute('data-str-idle') || 'Start typing to search.',
    empty: root.getAttribute('data-str-empty') || 'No matches.',
    none: root.getAttribute('data-str-none') || 'No results found.',
    error: root.getAttribute('data-str-error') || 'Search is unavailable right now.',
    loading: root.getAttribute('data-str-loading') || 'Searching...',
    viewAll: root.getAttribute('data-str-viewall') || 'View All Results',
    soldOut: root.getAttribute('data-str-soldout') || 'Sold out',
    recent: root.getAttribute('data-str-recent') || 'Recent searches',
    recentClear: root.getAttribute('data-str-recentclear') || 'Clear'
  };

  var timer = null;
  var controller = null;
  var active = 'products';
  var lastQuery = '';
  var canComplete = false;
  var GHOST_CLASS = 'hfb-ghosting';

  /* The completed tail is a real text selection, so the browser paints it as a
     highlight block. This class swaps that for faded text (see the CSS) and is
     kept OFF for a shopper's own selection, which must still look selected. */
  function clearGhost() { input.classList.remove(GHOST_CLASS); }

  /* Recent searches. localStorage, not sessionStorage: the ask is that a
     shopper can come back later and pick a search up again, and a session
     store is gone the moment the tab closes. Search TERMS only - nothing
     personal, nothing about what they viewed or bought. */
  var RECENT_KEY = 'hfb_recent_searches';
  var RECENT_MAX = 8;
  var data = { products: [], queries: [], collections: [] };

  /* Every storage call is wrapped: Safari private mode throws on read AND on
     write, and a quota error must not take the whole drawer down with it. */
  function readRecent() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (t) { return typeof t === 'string' && t.trim(); })
                .slice(0, RECENT_MAX);
    } catch (e) { return []; }
  }

  function remember(term) {
    term = String(term == null ? '' : term).trim();
    if (term.length < MIN_CHARS) return;
    var lower = term.toLowerCase();
    var list = readRecent().filter(function (t) { return t.toLowerCase() !== lower; });
    list.unshift(term);
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); }
    catch (e) { /* full or blocked - the history is a convenience, not a gate */ }
  }

  function forgetRecent() {
    try { window.localStorage.removeItem(RECENT_KEY); } catch (e) { /* no-op */ }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* suggest.json returns prices as decimal strings ("58.00").
     The theme's formatter expects cents, so convert before handing it over. */
  function money(value) {
    var amount = parseFloat(value);
    if (isNaN(amount)) return '';
    try {
      if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
        return theme.Shopify.formatMoney(Math.round(amount * 100), theme.money_format);
      }
    } catch (e) { /* fall through to the plain figure */ }
    return amount.toFixed(2);
  }

  function searchUrl(term) {
    return searchPath + '?q=' + encodeURIComponent(term) +
      '&type=' + encodeURIComponent(searchType) + '&options%5Bprefix%5D=last';
  }

  function recentHtml() {
    var list = readRecent();
    if (!list.length) return '';
    return '<div class="hfb-drawer__recent" data-hfb-recent>' +
      '<p class="hfb-drawer__recent-head">' + esc(strings.recent) +
        '<button type="button" class="hfb-drawer__recent-clear" data-hfb-recent-clear>' +
          esc(strings.recentClear) + '</button>' +
      '</p>' +
      '<ul class="hfb-drawer__list">' + list.map(function (t) {
        return '<li class="hfb-drawer__item hfb-drawer__item--text hfb-drawer__item--recent">' +
          '<a href="' + esc(searchUrl(t)) + '" data-hfb-term="' + esc(t) + '">' +
          esc(t) + '</a></li>';
      }).join('') + '</ul></div>';
  }

  /* Element.closest is not in the theme's browser floor, and the delegated
     handler must stop at the drawer body either way. */
  function closestEl(node, sel) {
    while (node && node !== body) {
      if (node.nodeType === 1 && node.matches && node.matches(sel)) return node;
      node = node.parentNode;
    }
    return null;
  }

  /* A Suggestions or Collections row navigates to a search URL - the term in
     it is a better thing to remember than whatever half-word was typed. */
  function hrefTerm(a) {
    var href = a.getAttribute('href') || '';
    if (href.indexOf(searchPath + '?') !== 0 && href.indexOf('/search?') !== 0) return '';
    var m = /[?&]q=([^&]*)/.exec(href);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return ''; }
  }

  function message(text) {
    return '<p class="hfb-drawer__msg">' + esc(text) + '</p>';
  }

  function productRow(p) {
    var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
    var thumb = img
      ? '<img class="hfb-drawer__thumb" src="' + esc(img) +
          (img.indexOf('?') === -1 ? '?' : '&amp;') +
          'width=120" alt="" loading="lazy" width="56" height="72">'
      : '<span class="hfb-drawer__thumb hfb-drawer__thumb--empty" aria-hidden="true"></span>';

    var price = money(p.price);
    var compare = parseFloat(p.compare_at_price_min);
    var current = parseFloat(p.price);
    var priceHtml = '';
    if (price) {
      priceHtml = (!isNaN(compare) && !isNaN(current) && compare > current)
        ? '<span class="hfb-drawer__was">' + money(p.compare_at_price_min) + '</span>' + price
        : price;
    }
    if (p.available === false) {
      priceHtml += '<span class="hfb-drawer__sold">' + esc(strings.soldOut) + '</span>';
    }

    return '<li class="hfb-drawer__item">' +
      '<a href="' + esc(p.url) + '">' + thumb +
        '<span class="hfb-drawer__item-text">' +
          '<span class="hfb-drawer__item-title">' + esc(p.title) + '</span>' +
          (priceHtml ? '<span class="hfb-drawer__item-price">' + priceHtml + '</span>' : '') +
        '</span>' +
      '</a></li>';
  }

  /* styled_text is Shopify-generated markup (<mark>/<span> around the matched
     stem). Rebuild it from escaped parts rather than trusting it wholesale. */
  function queryRow(q) {
    var label = q.styled_text
      ? String(q.styled_text).replace(/<(?!\/?(mark|span)\b)[^>]*>/gi, '')
      : esc(q.text);
    return '<li class="hfb-drawer__item hfb-drawer__item--text">' +
      '<a href="' + esc(q.url) + '">' + label + '</a></li>';
  }

  function collectionRow(c) {
    return '<li class="hfb-drawer__item hfb-drawer__item--text">' +
      '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
  }

  /* Inline type-ahead in the field itself: finish the word with the top native
     suggestion that extends what was typed, leaving the added tail SELECTED so
     the next keystroke overwrites it and Enter searches the completed term.
     Reuses the queries already fetched for the Suggestions tab - no extra
     request. Fires only on a plain forward keystroke, so backspacing never
     re-completes, and an IME composition (Android keyboards) is left alone
     because those report insertCompositionText, not insertText. */
  function inlineComplete(term) {
    if (!canComplete) return;
    if (input.value !== term) return;                       // a newer keystroke won
    if (input.selectionStart !== input.value.length) return; // caret is not at the end

    var lower = term.toLowerCase();
    var hit = null;
    for (var i = 0; i < data.queries.length; i++) {
      var text = data.queries[i] && data.queries[i].text;
      if (text && text.length > term.length && text.toLowerCase().indexOf(lower) === 0) {
        hit = text;
        break;
      }
    }
    if (!hit) return;

    input.value = term + hit.slice(term.length);
    try { input.setSelectionRange(term.length, input.value.length); } catch (e) { /* no-op */ }
    input.classList.add(GHOST_CLASS);
  }

  function render() {
    var term = lastQuery;

    if (term.length < MIN_CHARS) {
      body.innerHTML = (recentHtml() + trendingHtml) || message(strings.idle);
      setCounts(null);
      if (foot) foot.hidden = true;
      return;
    }

    var rows = data[active] || [];
    var renderer = active === 'products' ? productRow
      : active === 'queries' ? queryRow : collectionRow;

    body.innerHTML = rows.length
      ? '<ul class="hfb-drawer__list">' + rows.map(renderer).join('') + '</ul>'
      : message(data.products.length || data.queries.length || data.collections.length
          ? strings.empty : strings.none);

    if (foot && viewAll) {
      foot.hidden = false;
      viewAll.href = searchUrl(term);
      viewAll.textContent = strings.viewAll;
    }
  }

  function setCounts(counts) {
    tabs.forEach(function (tab) {
      var key = tab.getAttribute('data-hfb-tab');
      var el = tab.querySelector('[data-hfb-tab-count]');
      if (!el) return;
      el.textContent = counts && counts[key] ? '(' + counts[key] + ')' : '';
    });
  }

  function selectTab(key, focus) {
    active = key;
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-hfb-tab') === key;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
      if (on && focus) tab.focus();
    });
    render();
  }

  function fetchResults(term) {
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;

    /* limit_scope=each is required: the default ('all') spends ONE budget of
       LIMIT across all three resource types, which starves the Products tab. */
    var url = predictiveSearchPath + '?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=' + LIMIT + '&resources[limit_scope]=each';

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('suggest ' + r.status);
        return r.json();
      })
      .then(function (json) {
        if (term !== lastQuery) return; // a newer keystroke already won
        var res = (json.resources && json.resources.results) || {};
        data = {
          products: res.products || [],
          queries: res.queries || [],
          collections: res.collections || []
        };
        setCounts({
          products: data.products.length,
          queries: data.queries.length,
          collections: data.collections.length
        });
        render();
        inlineComplete(term);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (term !== lastQuery) return;
        body.innerHTML = message(strings.error);
        if (foot) foot.hidden = true;
        setCounts(null);
      });
  }

  function onInput(event) {
    clearGhost();
    /* Only a real forward keystroke may trigger a completion. Called with no
       event (focus, or accepting a completion) means never. */
    canComplete = !!(event && !event.isComposing && event.inputType === 'insertText');

    var term = input.value.trim();
    lastQuery = term;
    clearTimeout(timer);

    if (term.length < MIN_CHARS) {
      if (controller) { controller.abort(); controller = null; }
      data = { products: [], queries: [], collections: [] };
      render();
      return;
    }

    if (foot) foot.hidden = true;
    body.innerHTML = message(strings.loading);
    timer = setTimeout(function () { fetchResults(term); }, DEBOUNCE_MS);
  }

  /* One delegated handler for the body: clear the history, replay a term, or
     record the search that a clicked result came from. */
  body.addEventListener('click', function (e) {
    if (closestEl(e.target, '[data-hfb-recent-clear]')) {
      e.preventDefault();
      forgetRecent();
      render();
      return;
    }

    var replay = closestEl(e.target, '[data-hfb-term]');
    if (replay) {
      /* Modifier or middle click: leave the anchor alone so it opens the full
         results page in a new tab, as any other link would. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      input.value = replay.getAttribute('data-hfb-term');
      input.focus();
      onInput();   /* no event object -> no inline completion, just the search */
      return;
    }

    var result = closestEl(e.target, '.hfb-drawer__item > a');
    if (result) remember(hrefTerm(result) || input.value);
  });

  if (viewAll) {
    viewAll.addEventListener('click', function () { remember(lastQuery); });
  }

  input.addEventListener('input', onInput);
  input.addEventListener('mousedown', clearGhost);
  input.addEventListener('blur', clearGhost);

  /* Accept the completion: Tab, Right arrow or End collapse the selection to
     the end and re-run the search for the now-complete term. */
  input.addEventListener('keydown', function (e) {
    var hasGhost = input.selectionEnd > input.selectionStart &&
                   input.selectionEnd === input.value.length;
    if (!hasGhost) { clearGhost(); return; }
    /* The shopper is making a selection of their own (select-all, shift+arrow) -
       hand the normal highlight back before the selection changes under us. */
    if ((e.key === 'a' && (e.metaKey || e.ctrlKey)) ||
        (e.shiftKey && (e.key.indexOf('Arrow') === 0 || e.key === 'Home' || e.key === 'End'))) {
      clearGhost();
      return;
    }
    if (e.key === 'Tab' || e.key === 'ArrowRight' || e.key === 'End') {
      e.preventDefault();
      input.setSelectionRange(input.value.length, input.value.length);
      onInput();
    }
  });

  /* On /search the field arrives pre-filled. Fetch when the drawer opens rather
     than on every page load. The click hook covers the theme's edge case where
     it focuses .focus-me before this deferred asset has attached its listener. */
  function loadPrefilledSearch() {
    var term = input.value.trim();
    var hasRows = data.products.length || data.queries.length || data.collections.length;
    if (term.length >= MIN_CHARS && !hasRows) onInput();
  }

  input.addEventListener('focus', loadPrefilledSearch);
  Array.prototype.forEach.call(document.querySelectorAll('[data-modal-toggle="#search-modal"]'), function (opener) {
    opener.addEventListener('click', function () {
      window.setTimeout(loadPrefilledSearch, 0);
    });
  });

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      selectTab(tab.getAttribute('data-hfb-tab'), false);
    });
    tab.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(tab);
      if (e.key === 'ArrowRight') { e.preventDefault(); selectTab(tabs[(i + 1) % tabs.length].getAttribute('data-hfb-tab'), true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); selectTab(tabs[(i - 1 + tabs.length) % tabs.length].getAttribute('data-hfb-tab'), true); }
    });
  });

  /* Enter in the field keeps the native full-results behaviour. */
  if (form) {
    form.addEventListener('submit', function () {
      clearTimeout(timer);
      if (controller) controller.abort();
      remember(input.value);
    });
  }

  render();
}());
